import styled from 'styled-components';
import {Button} from '@guestapp/ui';
import {device} from '@guestapp/ui/src/utils/device';

export const LoginRow = styled.div`
  color: #152946;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
  padding: 8px;
`;

export const LoginLink = styled(Button)`
  color: ${({theme}) => theme.colors.branding.primary ?? '#385bf8'};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.15px;
`;

export const SeparatorRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;

export const Separator = styled.hr`
  flex: 1;
  border: none;
  border-top: 1.5px solid #e3e7ee;
  margin: 0 8px;
`;

export const Or = styled.span`
  color: #152946;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const SocialButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
`;

export const SocialAuthButton = styled(Button)`
  width: 100%;
  border: 1px solid #a9a9a9;
  color: #152946;
  margin-bottom: 8px;
`;

export const ContinueWithoutLoginButton = styled(Button)`
  width: 100%;
  color: #152946;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.15px;
  height: 64px;

  & .buttonLabel {
    margin-top: 4px;
  }
`;

export const WelcomeContainer = styled.div`
  @media (min-width: ${device.tablet}) {
    height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 16px 40px;
  }
`;

export const WelcomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: #f6f7fa;
  padding: 24px 24px 24px;
  min-height: 100vh;
  box-sizing: border-box;
  max-width: 375px;
  margin: 0 auto;

  @media (min-width: ${device.tablet}) {
    width: 375px;
    margin: auto;
    padding: 0 24px;
    transform: translateY(-95px);
    min-height: auto;
  }
`;

export const StyledImg = styled.img`
  margin-bottom: 24px;
  object-fit: contain;
  transform: rotate(-35deg);
`;

export const WelcomeTitle = styled.div`
  color: #152946;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.36px;
  margin-bottom: 12px;
  height: 32px;
`;

export const WelcomeSubtitle = styled.div`
  color: #152946;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-bottom: 48px;
`;

export const ContinueToReservationButton = styled(Button)`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 327px;
`;
